import React, { useState, createContext } from "react";
import { IReplaceTrackerForm, IReplaceTrackerFormValidation } from "../../interfaces/interface";

export const ReplaceTrackerContext = createContext<any>({});

export const ReplaceTrackerProvider: React.FC = (props) => {
    const [formInput, setFormInput] = useState<IReplaceTrackerForm>({
        assetName: "",
        assetType: "",
        oldDeviceId: "",
        newDeviceId: "",
        oldDeviceIdStatus:"",
      });
  
    const [formFieldsValid, setFormFieldsValid] = useState<IReplaceTrackerFormValidation>({
        assetName: {
            isValid: false,
            displayMessage: false,
            message: ""
        },
        assetType: {
            isValid: false,
            displayMessage: false,
            message: ""
        },
        oldDeviceId: {
            isValid: false,
            displayMessage: false,
            message: ""
        },
        newDeviceId: {
            isValid: false,
            displayMessage: false,
            message: ""
        },
        oldDeviceIdStatus: {
            isValid: false,
            displayMessage: false,
            message: ""
        },
    });
    const [errorMessage, setErrorMessage] =useState<string>("")
    const [filedBlock, setFieldBlock] = useState<boolean>(false);
    const [defaultSelect, setDefaultSelect] = useState<string>("")
  return (
    <ReplaceTrackerContext.Provider
      value={{
        Form: [formInput, setFormInput],
        formVal: [formFieldsValid, setFormFieldsValid],
        errMessage: [errorMessage, setErrorMessage],
        blockField: [filedBlock, setFieldBlock],
        selectDefault: [defaultSelect, setDefaultSelect],
      }}
    >
      {props.children}
    </ReplaceTrackerContext.Provider>
  );
};
